import { defineMessages } from 'react-intl';

export default defineMessages({
  sorting: {
    id: 'wishlist.sorting.label',
    defaultMessage: 'Řazení',
  },
  filtrationAll: {
    id: 'wishlist.filtration.categories.all',
    defaultMessage: 'Vše',
  },
  show: {
    id: 'wishlist.filtration.drawer.show',
    defaultMessage: 'Zobrazit',
  },
  brandsSearchPlaceholder: {
    id: 'wishlist.filtration.drawer.brands.search.placeholder',
    defaultMessage: 'Filtrujte značku psaním',
  },
});
